import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { CONFIG, PROFILE_URL } from '../config';
import config from '../config';

class CabinetErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
  }

  componentDidMount() {
    this.setState({
      mounted: true
    }, () => {
      document.getElementById('body').style.paddingBottom = 0;
      document.getElementById('body').style.minHeight = 'initial';
    });
  }

  componentWillUnmount() {
    document.getElementById('body').style.paddingBottom = '100px';
    document.getElementById('body').style.minHeight = '100vh';
  }

  render() {
    const { mounted } = this.state;
    const urlBaseForAssets = (config) => {
      if (config.match(/pre|prod/)) {
        return '/';
      } else {
        return '';
      }
    };
    return(
        <main style={{
          maxWidth: 500,
          margin: '80px auto -100px',
          padding: 15
        }}>
          <a href="https://www.kcell.kz/" className="logo d-lg-inline-block" style={{
            marginBottom: 15,
            display: 'inline-block'
          }} target="_blank" rel="noopener noreferrer">
            <img
              src={`images/kcell_logo_purple.svg`}
              height={35}
            />
          </a>

          <h1 className="h1" style={{marginBottom: 15}}>Возникли неполадки</h1>
          <article className="article">
            Со входом в Личный кабинет для услуги "Бизнес-телефония" возникли технические неполадки, мы уже активно работаем над их устранением.
            Обратитесь в Kcell для выяснения деталей.
          </article>
          {/*{CONFIG !== 'prod'*/}
            {/*&& <article className="article" style={{marginTop: 15}}>*/}
              {/*<p style={{marginBottom:5}}>Ошибка: {JSON.stringify(this.props.error)}</p>*/}
              {/*{this.props.url && <p>Эндпоинт: {JSON.stringify(this.props.url)}</p>}*/}
            {/*</article>}*/}
          <a href={config.accountsUrl} className="link link--line link--light-font" style={{fontSize:16}}>
            Перейти на страницу услуг
          </a>
        </main>
    );
  }
}

// export default connect(({apiCallResult}) => ({
//   error: apiCallResult.apiCallError.error,
//   url: apiCallResult.apiCallError.url
// }))(CabinetErrorPage);

export default CabinetErrorPage;
